import { Injectable } from '@angular/core';
import { defaultDwopenEndpoint, environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class InstanceService {

    get prefixKey() : string { return this.cookieService.get("app-center-instance"); }

    get appCenterUrl() : string {return this.prefixKey ? environment.instances[this.prefixKey]?.appCenter : null }
    get appCenterCurrentInstance() { return this.prefixKey ?  environment.instances[this.prefixKey]?.name : null }
    get appCenterInstanceUrl() { return this.prefixKey ? environment.instances[this.prefixKey]?.instancesUrl : null }
    get appCenterLnfUrl() { return this.prefixKey ? environment.instances[this.prefixKey]?.lnfUrl : null }
    get appCenterEndpoint() {
        return this.prefixKey && (environment.instances[this.prefixKey]?.endpoint)
        ? environment.instances[this.prefixKey].endpoint : defaultDwopenEndpoint;
    }

    get connectedApps(){
        return this.prefixKey ? environment.instances[this.prefixKey]?.connectedApps : {};
    }

    constructor(private cookieService: CookieService) { }
}
